const styles = theme => ({
  container: {
    position: 'fixed', // Changed from absolute to fixed
    top: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '92px',
    transform: 'translateY(-50%)',
    zIndex: 1300, // Should be higher than drawer but lower than modals
    cursor: 'pointer',
    transition: theme.transitions.create('left', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  buttonImage: {
    width: '24px',
    height: '92px',
  },
  icon: {
    position: 'absolute',
    zIndex: 1,
  },
})

export default styles
